import React, { useState, useCallback } from 'react';
import { Button } from '../../elements';
import { CREATE_BLOG, UPLOAD_BLOG_IMAGE } from './queries';
import { useMutation } from '@apollo/client';
import TrixEditor from './TrixEditor';
import { useForm } from 'react-hook-form';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';
import { View, Text, Dimensions } from 'react-native';
import AssignTags from './AssignTags';
import { elGray } from '../../styles/colors';

export const FIELDS = {
  title: {
    label: 'Title',
    rules: { required: true },
  },
  featured: {
    label: 'Featured',
    type: 'boolean'
  }
};

const dimensions = Dimensions.get('window');
const smallScreen = dimensions.width < 800;

const NewBlog = ({setShowModal, refetch}) => {
  const [content, setContent] = useState("");
  const [tagIds, setTagIds] = useState([]);
  const [formStatus, setFormStatus] = useState();
  const [mainPhoto, setMainPhoto] = useState();
  const [mainVideo, setMainVideo] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createBlog] = useMutation(CREATE_BLOG, {
    onCompleted: (response) => {
      setShowModal(false);
      setFormStatus('');
      if(refetch) {
        refetch();
      }
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    input['content'] = content;
    input['tagIds'] = tagIds;
    input['mainPhoto'] = mainPhoto || null;
    input['mainVideo'] = mainVideo || null;

    createBlog({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };

  return (
    <View
      style={{maxWidth: smallScreen ? '70%' : '100%'}}
    >
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />
      <Text>Main Photo</Text>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setMainPhoto(e.target.files[0])}
      />
      {mainPhoto ?
        <img
          src={URL.createObjectURL(mainPhoto)}
          style={{maxWidth: '50%'}}
        /> :
        null
      }
      <br />
      <Text>Main Video</Text>
      <input
        type="file"
        accept="video/*"
        onChange={(e) => setMainVideo(e.target.files[0])}
      />
      <br />
      <Text>Blog Content</Text>
      <View style={{minHeight: '200px', border: `2px solid ${elGray}`, maxWidth: '100%'}}>
        <TrixEditor
          content={content}
          setContent={setContent}
        />
      </View>
      <AssignTags
        selectedTags={tagIds}
        setSelectedTags={setTagIds}
      />
      <Button
        onClick={handleSubmit(onSubmit)}
        style={{fontWeight: 800}}
        disabled={formStatus === 'submitting'}
      >
        {formStatus === 'submitting' ? 'saving...' : 'Post Blog'}
      </Button>
    </View>
  )
}

export default NewBlog;